/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef } from "react";
import { Confirm, useNotify } from "react-admin";
import { useDispatch } from "react-redux";
import { API, graphqlOperation } from "aws-amplify";
import {
  barcodeByInventoryByStatusByLocation,
  barcodeByInventoryItemByActiveByValue,
  getLocation,
} from "../../../graphql/queries";
import { getInventoryItemMobile } from "../../../graphql/inventory/custom-queries";
import {
  searchInventorysInbound,
  inventoryItemByLocationByStatusInbound,
} from "../../../graphql/inventory/custom-queries";
import { updateBarcode, deleteBarcode } from "../../../graphql/mutations";
import { locationByAisleBySortKey } from "../../../graphql/reloadyard/custom-queries";
import LocationCapacity, {
  StructuredLocationCapacity,
} from "../../../components/common/LocationCapacity";
import {
  createInventoryItem,
  updateInventoryItem,
  deleteInventoryItemMini,
} from "../../../graphql/inventory/custom-mutations";
import { performUpdateInventoryMini } from "../../../graphql/inventory/inventoryCRUD";

import {
  Box,
  Button,
  Backdrop,
  CircularProgress,
  Divider,
  FormControlLabel,
  Grid,
  Switch,
  Typography,
  useMediaQuery,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import VisibilityIcon from "@material-ui/icons/Visibility";

import { logError } from "../../../utils/appUtils";
import {
  InventoryStatus,
  LocationType,
  NoteType,
} from "../../../utils/constants";
import { isRailCarNumberMatch } from "../../../utils/railCarUtils";
import {
  getLocationFullName,
  isBulkArea,
  isBulkLocation,
  isRailShipmentInTrackArea,
  isTrack,
  isTruckToRail,
  isUnmanagedLocation,
  promiseSetCapacityUsed,
  applyIsoTainerLocationUpdate,
} from "../../../utils/locationUtils";
import { getUnitName } from "../../../utils/loadTypeUtils";
import { getInitQuantityOnHand } from "../../../utils/utils";
import { isUnmanagedAisle } from "../../../utils/locationUtils";
import { BarcodesStatus } from "../../../utils/constants";

import SearchInput from "../../../components/common/SearchInput";

import { getTrackLocationRecordDisplayName } from "../../../components/common/locationPickerTrackUtils";
import { TrackLocationView } from "../../../components/common/TrackLocationView";
import { useWorkOrderContext } from "./context";
import { StructuredInboundAisle } from "./StructuredInboundAisle";
import { StructuredAisleControl } from "./StructuredAisleControl";
import {
  getRailcarVerificationSaveState,
  getTrackSaveBlockedMessage,
  getTargetRailcarVerificationState,
  TrackAisleControl,
} from "./TrackAisleControl";
import { BulkInboundAisle } from "./BulkInboundAisle";
import { BulkAisleControl } from "./BulkAisleControl";
import { UnstructuredAisleControl } from "./UnstructuredAisleControl";
import { InventoriesDialog } from "./InventoriesDialog";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: 10001,
  },
  iconButton: {
    marginTop: theme.spacing(0.25),
  },
  deleteButton: {
    marginTop: theme.spacing(0.25),
    color: theme.palette.error.main,
  },
}));

export const getWorkOrderTrackViewContext = ({
  currentInventory,
  currentShipment,
  selectedOutbound,
  selectedInventoryItem,
  selectedLocation,
  trackViewRailcarVerificationType,
}) => {
  const isTargetRailcarVerification =
    trackViewRailcarVerificationType === "receiving";
  const isInboundRailOnTrackArea = isRailShipmentInTrackArea(
    currentInventory?.areaId,
    currentShipment,
  );
  const selectedShipmentContext = isTargetRailcarVerification
    ? selectedOutbound || currentShipment
    : isInboundRailOnTrackArea
      ? currentShipment
      : selectedOutbound;
  const selectedTrack = selectedShipmentContext?.trackCar?.trackId
    ? {
        id: selectedShipmentContext.trackCar.trackId,
        locationFullName: selectedShipmentContext.trackCar.locationFullName,
      }
    : selectedInventoryItem?.location || selectedLocation || null;

  return {
    selectedTrack,
    trackId: selectedTrack?.id || "",
    highlightShipmentId: isTargetRailcarVerification
      ? selectedOutbound?.id ||
        selectedInventoryItem?.outboundShipmentId ||
        selectedShipmentContext?.id ||
        selectedInventoryItem?.inboundShipmentId ||
        null
      : selectedShipmentContext?.id ||
        selectedInventoryItem?.outboundShipmentId ||
        selectedInventoryItem?.inboundShipmentId ||
        null,
  };
};

// Inbound inline source verification is temporarily disabled for this screen.
// export const getSourceRailcarVerificationState = ({
//   currentInventory,
//   currentShipment,
//   isSourceRailcarValidated,
// }) => {
//   const expectedRailCarNumber = currentShipment?.railCarNumber || "";
//   const hasExpectedRailCarNumber = Boolean(
//     normalizeRailCarNumber(expectedRailCarNumber),
//   );
//   const requiresVerification =
//     isRailShipmentInTrackArea(currentInventory?.areaId, currentShipment) &&
//     currentShipment?.account?.verifyInboundRailCar === true &&
//     hasExpectedRailCarNumber;
//
//   return {
//     expectedRailCarNumber,
//     requiresVerification,
//     shouldHideSelectedRailcar:
//       requiresVerification && !isSourceRailcarValidated,
//   };
// };

export const getTrackViewRailcarVerificationConfig = ({
  // sourceRailcarVerificationState,
  targetRailcarVerificationState,
}) => {
  if (targetRailcarVerificationState?.shouldHideSelectedRailcar) {
    return {
      type: "receiving",
      hideSelectedRailcar:
        targetRailcarVerificationState.shouldHideSelectedRailcar,
    };
  }

  return {
    type: null,
    hideSelectedRailcar: false,
  };
};

export const InboundAisleMap = ({ refreshFn }) => {
  const { state, dispatch, saveInventory } = useWorkOrderContext();
  const {
    currentShipment,
    currentInventory,
    selectedAisle,
    selectedLocation,
    showInventoryQuantity,
    selectedInventoryItem,
    aisles,
    selectedOutbound,
    showCapacityDisplay,
    origInventoryItem,
    disableSelection,
    loading,
  } = state;
  const [locationInventories, setLocationInventories] = useState([]);
  const [isDeleteInventoryItemOpen, setIsDeleteInventoryItemOpen] =
    useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [showInventories, setShowInventories] = useState(false);
  const [isLocationInventoryLoading, setIsLocationInventoryLoading] =
    useState(false);
  const isSmall = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const dispatchRa = useDispatch();
  const notify = useNotify();
  const sourceInboundShipmentId =
    currentShipment?.inboundShipmentId || currentShipment?.id;
  const classes = useStyles();
  const [allBarcodes, setAllBarcodes] = useState([]);
  const [pendingBarcodes, setPendingBarcodes] = useState([]);
  const [showLocationChangeDialog, setShowLocationChangeDialog] =
    useState(false);
  const [pendingLocationId, setPendingLocationId] = useState(null);
  const [resolvedTrackLocation, setResolvedTrackLocation] = useState(null);
  const [targetRailcarInput, setTargetRailcarInput] = useState("");
  const [targetRailcarError, setTargetRailcarError] = useState(false);
  const [isTargetRailcarValidated, setIsTargetRailcarValidated] =
    useState(false);
  const pendingBarcodesRef = useRef([]);
  const targetRailcarVerificationState = getTargetRailcarVerificationState({
    selectedInventoryItem,
    selectedOutbound,
    isTargetRailcarValidated,
  });
  const trackViewRailcarVerificationConfig =
    getTrackViewRailcarVerificationConfig({
      targetRailcarVerificationState,
    });

  const handleValidateTargetRailcar = () => {
    if (
      isRailCarNumberMatch(
        targetRailcarVerificationState.expectedRailCarNumber,
        targetRailcarInput,
      )
    ) {
      setIsTargetRailcarValidated(true);
      setTargetRailcarError(false);
      notify("Receiving railcar validated successfully.");
      return;
    }

    setTargetRailcarError(true);
    notify(
      "Railcar number does not match. Enter the correct receiving railcar number.",
      "warning",
    );
  };

  const fetchPendingBarcodes = async () => {
    if (
      !currentInventory?.id ||
      !selectedInventoryItem?.locationId ||
      selectedInventoryItem?.id
    )
      return;

    try {
      const res = await API.graphql(
        graphqlOperation(barcodeByInventoryByStatusByLocation, {
          inventoryId: currentInventory.id,
          statusLocationId: {
            eq: {
              status: BarcodesStatus.NEW,
              locationId: selectedInventoryItem.locationId,
            },
          },
          limit: 1000,
        }),
      );

      const barcodes =
        res?.data?.barcodeByInventoryByStatusByLocation?.items || [];

      setPendingBarcodes(barcodes);
      setAllBarcodes(barcodes);
    } catch (err) {
      logError("InboundAisleMap:fetchPendingBarcodes", err, notify);
    }
  };

  useEffect(() => {
    fetchPendingBarcodes();
  }, [currentInventory?.id, selectedInventoryItem?.locationId]);

  useEffect(() => {
    if (selectedAisle?.id) handleAisleChange(selectedAisle.id);
  }, [selectedAisle?.id]);

  useEffect(() => {
    initializeData();
  }, [selectedInventoryItem?.id]);

  useEffect(() => {
    setTargetRailcarInput("");
    setTargetRailcarError(false);
    setIsTargetRailcarValidated(false);
  }, [currentShipment?.id, selectedInventoryItem?.id, selectedOutbound?.id]);

  const initializeData = async () => {
    if (!selectedInventoryItem?.id) return;

    try {
      dispatch({ type: "SET_LOADING", payload: true });

      const response = await API.graphql(
        graphqlOperation(getInventoryItemMobile, {
          id: selectedInventoryItem.id,
        }),
      );

      const inventoryItem = response.data.getInventoryItem;

      if (selectedAisle?.id) {
        await handleAisleChange(selectedAisle.id, inventoryItem);
      }

      if (selectedAisle && selectedLocation?.id) {
        handleLocation(selectedLocation);
      }

      dispatch({
        type: "SET_SELECTED_INVENTORY_ITEM",
        payload: { ...inventoryItem },
      });
    } catch (error) {
      logError("InboundAisleMap:getInventoryItem", error, notify);
    } finally {
      dispatch({ type: "SET_LOADING", payload: false });
    }
  };

  const isCurrentTrackArea = () => isTrack(currentInventory.areaId);

  // Truck container drop into a structured mobile-bulk grid (BULK_MOBILE) inside a bulk
  // receiving area. Uses structured aisle UI + isLocationAvailable; regular bulk flow
  // (BulkInboundAisle) only treats LocationType.BULK as placeable.
  const useBulkContainerFlow =
    currentShipment?.containerDrop === true &&
    selectedAisle?.type === LocationType.STRUCTURED &&
    isBulkArea(currentInventory?.area);

  useEffect(() => {
    let isCancelled = false;

    const resolveTrackLocation = async () => {
      if (!isCurrentTrackArea()) {
        setResolvedTrackLocation(null);
        return;
      }

      const { selectedTrack, trackId } = getWorkOrderTrackViewContext({
        currentInventory,
        currentShipment,
        selectedOutbound,
        selectedInventoryItem,
        selectedLocation,
        trackViewRailcarVerificationType:
          trackViewRailcarVerificationConfig.type,
      });

      if (!trackId) {
        setResolvedTrackLocation(null);
        return;
      }

      if (
        selectedTrack?.id === trackId &&
        selectedTrack?.areaId &&
        selectedTrack?.aisleId
      ) {
        setResolvedTrackLocation(selectedTrack);
        return;
      }

      const cachedLocation = window.appUser?.reloadYard?.locationMap?.[trackId];
      if (cachedLocation?.id) {
        if (!isCancelled) {
          setResolvedTrackLocation(cachedLocation);
        }
        return;
      }

      try {
        const response = await API.graphql(
          graphqlOperation(getLocation, { id: trackId }),
        );
        if (!isCancelled) {
          setResolvedTrackLocation(response?.data?.getLocation || null);
        }
      } catch (error) {
        if (!isCancelled) {
          setResolvedTrackLocation(null);
        }
        logError("InboundAisleMap:resolveTrackLocation", error, notify);
      }
    };

    resolveTrackLocation();

    return () => {
      isCancelled = true;
    };
  }, [
    currentInventory,
    currentShipment,
    selectedOutbound,
    selectedInventoryItem,
    selectedLocation,
    trackViewRailcarVerificationConfig.type,
  ]);

  const handleLocation = (location) => {
    debugger;
    if (isCurrentTrackArea()) return;
    setLocationInventories([]);

    if (location) {
      if (selectedInventoryItem?.locationId !== location.id) {
        if (allBarcodes.length > 0) {
          pendingBarcodesRef.current = [...allBarcodes];
          setPendingLocationId(location.id);
          setShowLocationChangeDialog(true);
        }
        setInventoryItemLocation(location, selectedInventoryItem);
        dispatch({
          type: "SET_SELECTED_INVENTORY_ITEM",
          payload: selectedInventoryItem,
        });
      }
      if (showLocationInventories()) getLocationInventories();
    } else {
      setInventoryItemLocation(null, selectedInventoryItem);
      dispatch({
        type: "SET_SELECTED_INVENTORY_ITEM",
        payload: selectedInventoryItem,
      });
    }
    const payload = location?.id === selectedLocation?.id ? null : location;
    dispatch({ type: "SET_SELECTED_LOCATION", payload });
  };

  const setInventoryItemLocation = (selectedLocation, inventoryItem) => {
    if (!selectedLocation?.id) {
      inventoryItem.areaId = null;
      inventoryItem.zoneId = null;
      inventoryItem.aisleId = null;
      inventoryItem.locationId = null;
      inventoryItem.location = null;
      return inventoryItem;
    }
    inventoryItem.areaId = selectedLocation.areaId;
    inventoryItem.zoneId = selectedLocation.zoneId;
    inventoryItem.aisleId = selectedLocation.aisleId;
    inventoryItem.locationId = selectedLocation.id;
    inventoryItem.location = selectedLocation;
    return inventoryItem;
  };

  const showLocationInventories = () => {
    return (
      selectedAisle?.id &&
      !isCurrentTrackArea() &&
      !isBulkArea(currentInventory?.area)
    );
  };

  const handleBarcodeLocationChange = async (locationId) => {
    const userBarcode = pendingBarcodesRef.current.filter(
      (barcode) => barcode.scannedIn === window.appUser?.fullName,
    );

    if (userBarcode.length > 0) {
      try {
        await Promise.all(
          userBarcode.map((barcode) =>
            API.graphql(
              graphqlOperation(updateBarcode, {
                input: {
                  id: barcode.id,
                  inventoryId: barcode.inventoryId,
                  status: barcode.status,
                  locationId: locationId,
                  value: barcode.value,
                  owner: barcode.owner,
                  active: barcode.active,
                  reloadYardId: barcode.reloadYardId,
                },
              }),
            ).catch((err) => {
              logError(
                "InboundAisleMap:handleBarcodeLocationChange",
                err,
                notify,
              );
            }),
          ),
        );
        await fetchPendingBarcodes();
      } catch (e) {
        logError("InboundAisleMap:handleBarcodeLocationChange", e, notify);
      }
    }
  };

  const handleCancelLocationChange = () => {
    setShowLocationChangeDialog(false);
    dispatch({
      type: "SET_SELECTED_INVENTORY_ITEM",
      payload: {
        ...selectedInventoryItem,
        quantityOnHand: 0,
      },
    });
  };

  const handleDialogConfirm = () => {
    if (pendingLocationId) {
      handleBarcodeLocationChange(pendingLocationId);
    }
    setShowLocationChangeDialog(false);
    setPendingLocationId(null); // clean up
  };

  const handleAisleChange = async (
    aisleId,
    inventoryItemOverride = null,
    options = {},
  ) => {
    try {
      const { userInitiated = false } = options;
      const item = inventoryItemOverride || selectedInventoryItem;
      if (!aisleId || aisles.length === 0) return;
      dispatch({ type: "SET_LOADING", payload: true });

      const response = await API.graphql(
        graphqlOperation(locationByAisleBySortKey, { aisleId, limit: 600 }),
      );

      const aisle = aisles.find((itm) => itm.id === aisleId);
      if (!aisle) return;

      aisle.locations = response.data.locationByAisleBySortKey.items.filter(
        (itm) => itm.active === "true",
      );

      const { showCapacityDisplay, bayList } = setupAisle(aisle);

      let location;

      if (origInventoryItem?.aisleId === aisle.id) {
        location = origInventoryItem.location;
      } else if (isUnmanagedAisle(aisle)) {
        location = aisle.locations[0];
      } else {
        location = null;
        item.areaId = null;
        item.zoneId = null;
        item.aisleId = null;
        item.locationId = null;
      }

      if (
        origInventoryItem?.aisleId !== aisle.id ||
        origInventoryItem?.locationId !== item?.locationId
      ) {
        if (allBarcodes.length > 0) {
          pendingBarcodesRef.current = [...allBarcodes];
          setPendingLocationId(location?.id);
          setShowLocationChangeDialog(true);
        }
      }

      let quantityOnHand = item.quantityOnHand;
      if (!disableSelection) {
        quantityOnHand = getInitQuantityOnHand(currentInventory, item, aisle);
      }

      const inventoryItem = {
        ...item,
        quantityOnHand,
        location,
      };

      if (location) {
        inventoryItem.areaId = location.areaId;
        inventoryItem.zoneId = location.zoneId;
        inventoryItem.aisleId = location.aisleId;
        inventoryItem.locationId = location.id;
        inventoryItem.location = location;
      }

      const payload = {
        aisle,
        bayList,
        showCapacityDisplay,
        selectedLocation: location,
        selectedInventoryItem: inventoryItem,
      };

      dispatch({ type: "SET_SELECTED_AISLE", payload });
      if (!disableSelection && userInitiated) {
        const lastSelectedPayload = {
          aisle,
          shipmentId:
            sourceInboundShipmentId || currentInventory?.inboundShipmentId,
        };
        dispatchRa({
          type: "SET_LAST_SELECTED_AISLE",
          payload: lastSelectedPayload,
        });
      }

      if (showCapacityDisplay) getShowQuantity();
    } catch (err) {
      logError(
        "processWorkOrders:WorkOrderAisleMap:handleAisleChange",
        err,
        notify,
      );
    } finally {
      dispatch({ type: "SET_LOADING", payload: false });
    }
  };

  const setupAisle = (aisle) => {
    const bayList = [];
    if (aisle.type === LocationType.UNSTRUCTURED) {
      return { showCapacityDisplay: false, bayList: [null, [aisle.locations]] };
    }
    const capacityTypeMap = {
      pallet: {},
      box: {},
      container: {},
      superSack: {},
    };
    let showRadio = true;

    for (let location of aisle.locations) {
      const bay = location.bay;
      if (!bayList[bay]) bayList[bay] = [];
      const level = location.level;
      if (!bayList[bay][level - 1]) bayList[bay][level - 1] = [];
      bayList[bay][level - 1].push(location);

      if (location.locationLoad?.other.selected) showRadio = false;
      if (location.locationLoad?.pallet.selected)
        capacityTypeMap["pallet"][location.locationLoad?.pallet.capacity] =
          true;
      if (location.locationLoad?.box.selected)
        capacityTypeMap["box"][location.locationLoad?.box.capacity] = true;
      if (location.locationLoad?.container.selected)
        capacityTypeMap["container"][
          location.locationLoad?.container.capacity
        ] = true;
      if (location.locationLoad?.superSack.selected)
        capacityTypeMap["superSack"][
          location.locationLoad?.superSack.capacity
        ] = true;
    }
    let showCapacityDisplay = false;
    if (showRadio) {
      const capacityTypeMapValues = Object.values(capacityTypeMap);
      const numberOfCapacities = capacityTypeMapValues.reduce(
        (total, itm) => (total += Object.keys(itm).length > 0 ? 1 : 0),
        0,
      );
      if (numberOfCapacities === 1) showCapacityDisplay = true;
    }
    if (isBulkArea(aisle.area)) showCapacityDisplay = true;
    bayList.splice(0, 1);
    for (let bay of bayList) {
      if (!bay || bay.length === 0) continue;
      for (let level of bay) {
        level.sort((a, b) => {
          return a.position - b.position;
        });
      }
    }

    return { showCapacityDisplay, bayList };
  };

  const setLocationCapacity = async (
    removeFlag = false,
    inventoryItem = selectedInventoryItem,
    options = {},
  ) => {
    const { forceFullCapacityAdd = false } = options;
    const loc = inventoryItem?.location;
    if (!loc) {
      return Promise.resolve({});
    }
    if (isUnmanagedLocation(loc)) {
      return Promise.resolve({});
    }

    const toLocation = { ...loc };
    if (
      toLocation.type === LocationType.BULK_MOBILE &&
      selectedAisle?.locationLoad?.container?.selected &&
      !toLocation.locationLoad?.container?.selected
    ) {
      toLocation.locationLoad = {
        ...(toLocation.locationLoad || {}),
        container: {
          ...(selectedAisle.locationLoad?.container || {}),
          selected: true,
        },
      };
    }
    const inventoryLoadType =
      currentInventory.reloadYardCommodity?.commodity?.locationLoadType;
    const locationLoadType =
      inventoryLoadType && toLocation.locationLoad
        ? toLocation.locationLoad[inventoryLoadType]
        : undefined;
    const needsLoadCapacitySelection =
      toLocation.type !== LocationType.BULK &&
      !(
        toLocation.type === LocationType.BULK_MOBILE &&
        toLocation.locationLoad?.container?.selected
      );
    if (
      toLocation.locationLoad?.container?.selected &&
      toLocation.type === LocationType.BULK_MOBILE
    ) {
      applyIsoTainerLocationUpdate({
        toLocation,
        inventory: currentInventory,
        shipment: currentShipment,
        account: currentShipment?.account,
        inventoryItem,
        removeFlag,
      });
      return promiseSetCapacityUsed(toLocation);
    }

    if (toLocation.type === LocationType.BULK || locationLoadType?.selected) {
      if (removeFlag) {
        const capacityToRemove =
          toLocation.type === LocationType.BULK
            ? Number(inventoryItem.quantityOnHand || 0)
            : locationLoadType.capacity;

        if (inventoryItem.status === InventoryStatus.IN_TRANSIT) {
          // Preassigned location with a allocated capacity
          toLocation.capacityAllocated =
            toLocation.capacityAllocated - capacityToRemove;
        } else {
          toLocation.capacityUsed = toLocation.capacityUsed - capacityToRemove;
        }
        if (
          toLocation.type !== LocationType.BULK &&
          toLocation.capacityUsed === 0
        ) {
          toLocation.productId = null;
          toLocation.productName = null;
          toLocation.accountName = null;
        }
        // isContaminated is deliberately left alone: taking the stock back out
        // does not clean the tank -- see canStoreInBulkTank.
      } else {
        const capacityToAdd =
          toLocation.type === LocationType.BULK
            ? forceFullCapacityAdd
              ? Number(inventoryItem.quantityOnHand || 0)
              : Number(inventoryItem.quantityOnHand || 0) -
                Number(origInventoryItem?.quantityOnHand || 0)
            : locationLoadType.capacity;

        if (inventoryItem.status === InventoryStatus.IN_TRANSIT) {
          toLocation.capacityAllocated =
            toLocation.capacityAllocated - capacityToAdd;
        }
        toLocation.capacityUsed = toLocation.capacityUsed + capacityToAdd;
        if (toLocation.type !== LocationType.BULK) {
          toLocation.productId = currentInventory.productId;
          toLocation.productName = currentInventory.productName;
          toLocation.accountName = currentInventory.accountName;
        }
        // A damaged load contaminates the whole tank. isBulkLocationAvailable
        // only lets this happen into an empty or already-contaminated tank.
        if (toLocation.type === LocationType.BULK && inventoryItem.isDamaged) {
          toLocation.isContaminated = true;
        }
      }
      return promiseSetCapacityUsed(toLocation);
    }

    if (inventoryLoadType && needsLoadCapacitySelection) {
      const hasLocationLoad = Boolean(toLocation.locationLoad);
      const hasRequiredLoadEntry = Boolean(
        toLocation.locationLoad &&
        Object.prototype.hasOwnProperty.call(
          toLocation.locationLoad,
          inventoryLoadType,
        ),
      );
      logError(
        "InboundAisleMap:setLocationCapacity:missingOrPartialLocationLoad",
        {
          inventoryId: currentInventory?.id,
          inventoryItemId: inventoryItem?.id,
          locationId: toLocation?.id,
          locationType: toLocation?.type,
          removeFlag,
          inventoryLoadType,
          hasLocationLoad,
          hasRequiredLoadEntry,
          locationLoadTypeSelected: locationLoadType?.selected,
        },
        null,
      );
    }
    return Promise.resolve({});
  };

  const updateException = async () => {
    dispatch({ type: "SET_LOADING", payload: true });

    const exceptionFlag = selectedInventoryItem.hasException;
    const verificationRequired = String(exceptionFlag);

    try {
      const [inventoryItemRes] = await Promise.all([
        API.graphql(
          graphqlOperation(updateInventoryItem, {
            input: {
              id: selectedInventoryItem.id,
              hasException: exceptionFlag,
              isDamaged: selectedInventoryItem.isDamaged,
              originOfDamage: selectedInventoryItem.originOfDamage,
            },
          }),
        ),
        performUpdateInventoryMini({
          id: currentInventory.id,
          hasException: exceptionFlag,
          verificationRequired,
        }),
      ]);

      const updatedInventoryItem = inventoryItemRes.data.updateInventoryItem;

      dispatch({
        type: "SET_SELECTED_INVENTORY_ITEM",
        payload: { ...selectedInventoryItem, ...updatedInventoryItem },
      });

      dispatch({
        type: "SET_SELECTED_INVENTORY",
        payload: {
          ...currentInventory,
          hasException: exceptionFlag,
          verificationRequired,
        },
      });

      await refreshFn(true);
    } catch (e) {
      logError("InboundAisleMap:updateException", e, notify);
    } finally {
      dispatch({ type: "SET_LOADING", payload: false });
    }
  };

  const handleSave = async (
    { isUpdatingShipment } = { isUpdatingShipment: false },
  ) => {
    if (isUpdatingShipment) {
      await updateException();
      return;
    }

    const railcarVerificationSaveState = getRailcarVerificationSaveState({
      requiresTargetRailcarVerification:
        targetRailcarVerificationState.requiresVerification,
      isTargetRailcarValidated,
    });

    if (railcarVerificationSaveState.isBlocked) {
      notify(
        getTrackSaveBlockedMessage(railcarVerificationSaveState.blockedBy),
        "warning",
      );
      return;
    }

    const oldStatus = selectedInventoryItem.status;
    let newInventoryItem = { ...selectedInventoryItem };
    if (
      isBulkLocation(selectedInventoryItem.location) &&
      !currentShipment.containerNumber?.trim()
    ) {
      newInventoryItem.status = InventoryStatus.AGGREGATED;
    } else {
      if (isCurrentTrackArea()) {
        newInventoryItem.status = InventoryStatus.STORED;
      } else if (selectedInventoryItem.status !== InventoryStatus.STORED) {
        newInventoryItem.status = InventoryStatus.UNLOADED;
      }
    }
    let oldQuantityOnHand;
    if (newInventoryItem.id) {
      try {
        const res = await API.graphql(
          graphqlOperation(barcodeByInventoryItemByActiveByValue, {
            inventoryItemId: selectedInventoryItem.id,
            active: "true",
          }),
        );

        const barcodes =
          res.data?.barcodeByInventoryItemByActiveByValue.items || [];
        setAllBarcodes(barcodes);
        if (barcodes.length > 0) {
          newInventoryItem.quantityOnHand = barcodes.length;
        } else {
          oldQuantityOnHand = origInventoryItem.quantityOnHand;
        }
      } catch (error) {
        logError("InboundAisleMap:handleSave", error, notify);
      }
    }
    const locationChanged =
      Boolean(newInventoryItem.id) &&
      Boolean(origInventoryItem?.locationId) &&
      Boolean(newInventoryItem.locationId) &&
      origInventoryItem.locationId !== newInventoryItem.locationId;

    try {
      dispatch({ type: "SET_LOADING", payload: true });
      const promiseList = [];

      if (
        locationChanged &&
        origInventoryItem?.location &&
        !isUnmanagedLocation(origInventoryItem.location)
      ) {
        await setLocationCapacity(true, origInventoryItem);
      }
      if (
        newInventoryItem.location &&
        !isUnmanagedLocation(newInventoryItem.location)
      ) {
        await setLocationCapacity(false, newInventoryItem, {
          forceFullCapacityAdd: locationChanged,
        });
      }

      currentInventory.active = true;
      currentInventory.inventoryItems.items =
        currentInventory.inventoryItems.items.map((itm) =>
          itm.id === newInventoryItem.id ? newInventoryItem : itm,
        );
      let totalQuantityOnHand = currentInventory.inventoryItems.items.reduce(
        (total, itm) => total + Number(itm.quantityOnHand || 0),
        0,
      );

      if (newInventoryItem.isDamaged) {
        currentInventory.hasException = true;
        currentInventory.isDamaged = true;
        currentInventory.verificationRequired = "true";
      } else {
        let isDamaged = false;
        let hasException = false;
        currentInventory.inventoryItems.items.forEach((itm) => {
          if (itm.isDamaged) isDamaged = true;
          if (itm.hasException) hasException = true;
        });
        if (!isDamaged) currentInventory.isDamaged = false;
        if (!hasException) currentInventory.hasException = false;
      }
      let historyText;
      let addHistory = true;
      if (newInventoryItem.id) {
        if (oldStatus === InventoryStatus.IN_TRANSIT) {
          historyText = `Placed ${
            newInventoryItem.quantityOnHand
          } ${getUnitName(
            currentInventory.inventoryUOM,
          )} in ${getLocationFullName(newInventoryItem.location)}`;
        } else {
          if (oldQuantityOnHand === newInventoryItem.quantityOnHand)
            addHistory = false;
          else
            historyText = `Quantity changed from ${oldQuantityOnHand} to ${
              newInventoryItem.quantityOnHand
            } ${getUnitName(currentInventory.inventoryUOM)}`;
        }
        if (addHistory) {
          const itemHistory = {
            type: NoteType.SHIPMENT,
            date: new Date(),
            by: window.appUser?.fullName,
            text: historyText,
          };
          newInventoryItem.history.push(itemHistory);
        }

        promiseList.push(doUpdateInventoryItem(newInventoryItem));
      } else {
        totalQuantityOnHand += Number(newInventoryItem.quantityOnHand || 0);
        historyText = `Placed ${newInventoryItem.quantityOnHand} ${getUnitName(
          currentInventory.inventoryUOM,
        )} in ${getLocationFullName(newInventoryItem.location)}`;
        const itemHistory = {
          type: NoteType.SHIPMENT,
          date: new Date(),
          by: window.appUser?.fullName,
          text: historyText,
        };
        newInventoryItem.history = [itemHistory];
        const createdItemResponse =
          await doCreateInventoryItem(newInventoryItem);
        newInventoryItem = createdItemResponse.data.createInventoryItem;
      }
      if (addHistory) {
        const newHistory = {
          type: NoteType.SHIPMENT,
          date: new Date(),
          by: window.appUser?.fullName,
          text: historyText,
        };
        currentInventory.history.push(newHistory);
      }
      try {
        const barcodes = allBarcodes || [];
        const newBarcodes = barcodes.filter(
          (b) => b.status === BarcodesStatus.NEW && b.id,
        );

        await Promise.all(
          newBarcodes.map((barcode) =>
            API.graphql(
              graphqlOperation(updateBarcode, {
                input: {
                  id: barcode.id,
                  inventoryId: barcode.inventoryId,
                  locationId: barcode.locationId,
                  inventoryItemId: newInventoryItem.id,
                  status: BarcodesStatus.PLACED,
                  value: barcode.value,
                  owner: barcode.owner,
                  active: barcode.active,
                  reloadYardId: barcode.reloadYardId,
                },
              }),
            ),
          ),
        );
      } catch (error) {
        logError("handleSave:updateUncommittedBarcodes", error, notify);
        notify("Failed to assign barcodes to new item", "error");
      }

      promiseList.push(saveInventory(currentInventory, totalQuantityOnHand));
      const response = await Promise.all(promiseList);
      const resError = response.find((itm) => itm.status === "rejected");
      if (resError) throw resError;
      await refreshFn(true);
      dispatch({ type: "SET_SELECTED_INVENTORY_ITEM", payload: null });
    } catch (err) {
      logError(
        "processWorkOrders:WorkOrderInventoryItems:handleSave:data",
        newInventoryItem,
        notify,
      );
      logError(
        "processWorkOrders:WorkOrderInventoryItems:handleSave",
        err,
        notify,
      );
    } finally {
      dispatch({ type: "SET_LOADING", payload: false });
    }
  };

  const doUpdateInventoryItem = async (toUpdateInventoryItem) => {
    toUpdateInventoryItem.locationFullName = getLocationFullName(
      toUpdateInventoryItem.location,
    );
    toUpdateInventoryItem = { ...toUpdateInventoryItem };
    if (isTruckToRail(currentInventory.areaId, currentShipment)) {
      toUpdateInventoryItem.quantityCommitted =
        toUpdateInventoryItem.quantityOnHand;
    } else toUpdateInventoryItem.quantityCommitted = 0;

    toUpdateInventoryItem.inventoryId = currentInventory.id;
    if (!toUpdateInventoryItem.unloadedBy) {
      toUpdateInventoryItem.unloadedBy = window.appUser.fullName;
      toUpdateInventoryItem.unloadedAt = new Date();
    }
    delete toUpdateInventoryItem.aisle;
    delete toUpdateInventoryItem.area;
    delete toUpdateInventoryItem.createdAt;
    delete toUpdateInventoryItem.inventory;
    delete toUpdateInventoryItem.location;
    delete toUpdateInventoryItem.seals;
    delete toUpdateInventoryItem.updatedAt;
    delete toUpdateInventoryItem.zone;
    delete toUpdateInventoryItem.barcodes;

    return API.graphql(
      graphqlOperation(updateInventoryItem, { input: toUpdateInventoryItem }),
    );
  };

  const doCreateInventoryItem = async (toCreateInventoryItem) => {
    const itemPayload = { ...toCreateInventoryItem };

    itemPayload.inboundShipmentId = sourceInboundShipmentId;

    if (isTruckToRail(currentInventory.areaId, currentShipment)) {
      itemPayload.quantityCommitted = itemPayload.quantityOnHand;
    } else {
      itemPayload.quantityCommitted = 0;
    }

    Object.assign(itemPayload, {
      accountId: currentInventory.accountId,
      groups: currentInventory.groups,
      owner: currentInventory.owner,
      inventoryId: currentInventory.id,
      reloadYardId: currentInventory.reloadYardId,
    });

    itemPayload.locationFullName = getLocationFullName(itemPayload.location);
    itemPayload.unloadedBy = window.appUser.fullName;
    itemPayload.unloadedAt = new Date();

    ["location", "inventory", "createdAt", "updatedAt"].forEach((key) => {
      delete itemPayload[key];
    });

    return API.graphql(
      graphqlOperation(createInventoryItem, { input: itemPayload }),
    );
  };

  const handleDelete = async () => {
    try {
      setIsDeleteInventoryItemOpen(false);
      dispatch({ type: "SET_LOADING", payload: true });
      let toDelete = origInventoryItem;

      currentInventory.inventoryItems.items =
        currentInventory.inventoryItems.items.filter(
          (itm) => itm.id !== toDelete.id,
        );

      const barcodesToDelete = toDelete?.barcodes?.items || [];

      const promiseList = [];
      promiseList.push(
        ...barcodesToDelete.map((barcode) =>
          API.graphql(
            graphqlOperation(deleteBarcode, {
              input: { id: barcode.id },
            }),
          ),
        ),
      );

      const input = { id: toDelete.id };
      promiseList.push(setLocationCapacity(true, toDelete));
      promiseList.push(
        API.graphql(graphqlOperation(deleteInventoryItemMini, { input })),
      );

      const quantityOnHand = currentInventory.inventoryItems.items.reduce(
        (total, itm) =>
          total +
          Number((itm.id === toDelete.id ? 0 : itm.quantityOnHand) || 0),
        0,
      );
      if (currentInventory.status === InventoryStatus.UNLOADED) {
        currentInventory.status = InventoryStatus.ARRIVED;
      }
      const historyText = `Removed ${
        origInventoryItem.quantityOnHand
      } ${getUnitName(currentInventory.inventoryUOM)} from ${
        origInventoryItem.locationFullName
      }`;
      const newHistory = {
        type: NoteType.SHIPMENT,
        date: new Date(),
        by: window.appUser?.fullName,
        text: historyText,
      };
      if (currentInventory.history) currentInventory.history.push(newHistory);
      else currentInventory.history = [newHistory];

      currentInventory.isDamaged = currentInventory.inventoryItems.items.some(
        (itm) => itm.isDamaged,
      );
      currentInventory.hasException =
        currentInventory.isDamaged ||
        currentInventory.overShipment ||
        currentInventory.underShipment ||
        currentInventory.otherException;
      currentShipment.hasException = currentInventory.hasException;
      promiseList.push(saveInventory(currentInventory, quantityOnHand));
      await Promise.all(promiseList);
      await refreshFn(true);
      dispatch({ type: "SET_SELECTED_INVENTORY_ITEM", payload: null });
    } catch (err) {
      logError(
        "processWorkOrders:WorkOrderInventoryItems:handleDelete",
        err,
        notify,
      );
    }
  };

  const handleClose = () => {
    refreshFn(true);
  };

  const getConfirmDialogText = () => {
    if (selectedInventoryItem && selectedInventoryItem.location) {
      return `Are you sure you want to remove ${
        selectedInventoryItem.quantityOnHand
      } ${getUnitName(
        currentInventory.inventoryUOM,
      )} from ${getLocationFullName(selectedInventoryItem.location)}`;
    }
    return "";
  };

  const handleDeleteButtonClick = () => {
    if (
      !currentInventory.inventoryItems.items.find(
        (itm) => itm.locationId === selectedLocation.id,
      )
    ) {
      return;
    }
    setIsDeleteInventoryItemOpen(true);
  };

  const getLocationInventories = async () => {
    try {
      if (!selectedLocation?.id || isLocationInventoryLoading) return;
      setIsLocationInventoryLoading(true);
      const results = await Promise.all([
        API.graphql(
          graphqlOperation(inventoryItemByLocationByStatusInbound, {
            locationId: selectedLocation.id,
            status: { beginsWith: InventoryStatus.IN_TRANSIT },
          }),
        ),
        API.graphql(
          graphqlOperation(inventoryItemByLocationByStatusInbound, {
            locationId: selectedLocation.id,
            status: { beginsWith: InventoryStatus.UNLOADED },
          }),
        ),
        API.graphql(
          graphqlOperation(inventoryItemByLocationByStatusInbound, {
            locationId: selectedLocation.id,
            status: { beginsWith: InventoryStatus.REVIEW },
          }),
        ),
        API.graphql(
          graphqlOperation(inventoryItemByLocationByStatusInbound, {
            locationId: selectedLocation.id,
            status: { beginsWith: InventoryStatus.STORED },
          }),
        ),
      ]);
      const inventoryItemsList = [
        ...results[0].data.inventoryItemByLocationByStatus.items,
        ...results[1].data.inventoryItemByLocationByStatus.items,
        ...results[2].data.inventoryItemByLocationByStatus.items,
        ...results[3].data.inventoryItemByLocationByStatus.items,
      ];
      if (inventoryItemsList.length > 0) {
        inventoryItemsList.sort((a, b) => {
          // Sort by accountName ASCENDING
          const accountNameCompare = a.inventory.accountName.localeCompare(
            b.inventory.accountName,
          );
          if (accountNameCompare !== 0) return accountNameCompare;

          // If accountName is the same, sort by productName ASCENDING
          const productNameNameCompare = a.inventory.productName.localeCompare(
            b.inventory.productName,
          );
          if (productNameNameCompare !== 0) return productNameNameCompare;

          // If productName is also the same, sort by quantityOnHand DESCENDING
          return b.quantityOnHand - a.quantityOnHand;
        });
        setLocationInventories(inventoryItemsList);
      }
    } catch (error) {
      logError(
        "workOrders:WorkOrderAisleMap:getLocationInventories",
        error,
        notify,
      );
    } finally {
      setIsLocationInventoryLoading(false);
    }
  };

  const isShipmentInventoryItem = (inventoryItem) => {
    return inventoryItem.inventoryId === currentInventory.id;
  };

  const searchAisleInventories = async () => {
    try {
      if (searchTerm.length === 0) return;
      dispatch({ type: "SET_LOADING", payload: true });
      const searchInput = {
        sort: { field: "productName", direction: "asc" },
        filter: {
          reloadYardId: { eq: window.appUser.reloadYardId },
          or: [
            { status: { eq: InventoryStatus.STORED } },
            { status: { eq: InventoryStatus.UNLOADED } },
          ],
          aisleList: { match: selectedAisle.id },
        },
        limit: 1000,
      };
      const term = searchTerm.toLowerCase();
      searchInput.filter.or = [
        { productCode: { matchPhrasePrefix: `${term}` } },
        { productCode: { wildcard: `*${term}*` } },
        { productName: { matchPhrasePrefix: `${term}` } },
        { productName: { wildcard: `*${term}*` } },
        { accountName: { matchPhrasePrefix: `${term}` } },
        { accountName: { wildcard: `*${term}*` } },
        { lotNumber: { matchPhrase: `${term}` } },
        { lotNumber: { wildcard: `*${term}*` } },
        { railCarNumber: { matchPhrasePrefix: `${term}` } },
        { railCarNumber: { wildcard: `*${term}*` } },
        { customFields: { matchPhrasePrefix: `${term}` } },
        { customFields: { wildcard: `*${term}*` } },
      ];
      const response = await API.graphql(
        graphqlOperation(searchInventorysInbound, searchInput),
      );
      const data = response.data.searchInventorys.items;
      setupAisleInventoryItems(data);
    } catch (err) {
      logError(
        "processWorkOrders:WorkOrderAisleMap:showInventory",
        err,
        notify,
      );
    } finally {
      dispatch({ type: "SET_LOADING", payload: false });
    }
  };

  const setupAisleInventoryItems = (inventories) => {
    const aisleInventoryItems = [];
    inventories.forEach((inventory) => {
      const inventoryItems = inventory.inventoryItems.items.filter(
        (itm) => itm.aisleId === selectedAisle.id,
      );
      aisleInventoryItems.push(...inventoryItems);
    });
    const searchInventoryItemsMap = {};
    aisleInventoryItems.forEach((itm) => {
      const locationInventories = searchInventoryItemsMap[itm.locationId];
      if (!locationInventories) searchInventoryItemsMap[itm.locationId] = [itm];
      else searchInventoryItemsMap[itm.locationId].push(itm);
    });
    dispatch({
      type: "SET_AISLE_SEARCH_INVENTORIES",
      payload: searchInventoryItemsMap,
    });
  };

  const clearSearchResults = () => {
    setSearchTerm("");
    dispatch({ type: "SET_AISLE_SEARCH_INVENTORIES", payload: {} });
  };

  const getShowQuantity = () => {
    let showValue;
    if (
      currentInventory.reloadYardCommodity?.commodity?.locationLoadType ===
      "other"
    ) {
      showValue = false;
    } else {
      showValue = localStorage.getItem("locationCapacityDisplay");
      showValue = showValue !== null ? JSON.parse(showValue) : false;
    }
    dispatch({ type: "SET_SHOW_QUANTITY", payload: showValue });
  };

  const handleDisplayChange = (evt) => {
    setShowQuantity(evt.target.checked);
  };

  const setShowQuantity = (value) => {
    localStorage.setItem("locationCapacityDisplay", value);
    dispatch({ type: "SET_SHOW_QUANTITY", payload: value });
  };

  const getSwitchLabel = () => {
    if (showInventoryQuantity) return "Storage units";
    return "Percentage";
  };

  const getLocationCapacity = () => {
    if (isCurrentTrackArea() || isBulkArea(currentInventory?.area)) return null;
    if (selectedAisle?.type === LocationType.UNSTRUCTURED) {
      return (
        <Grid item xs={12}>
          <LocationCapacity aisle={selectedAisle} />
        </Grid>
      );
    } else if (
      selectedAisle &&
      selectedLocation?.locationLoad &&
      selectedLocation?.locationLoad["other"].selected
    ) {
      return (
        <Grid item xs={12}>
          <StructuredLocationCapacity
            location={selectedLocation}
            updateFn={() => handleAisleChange(selectedAisle.id)}
          />
        </Grid>
      );
    }
    return null;
  };

  const getSelectedLocationText = () => {
    if (selectedLocation)
      return `Selected location: ${getLocationFullName(selectedLocation)}`;
    // return `Select a location in ${currentShipment.area.name}-${currentShipment.zone.name}`;
    return (
      <Box display="flex" alignItems="center">
        <Typography component="span">Area: &nbsp;</Typography>
        <Typography component="span">{currentInventory?.area?.name}</Typography>
        &nbsp;&nbsp;-&nbsp;&nbsp;
        <Typography component="span">Zone: &nbsp;</Typography>
        <FiberManualRecordIcon
          style={{ color: currentInventory?.zone?.color }}
        />
        <Typography component="span">{currentInventory?.zone?.name}</Typography>
      </Box>
    );
  };

  const getLocationControl = () => {
    if (isCurrentTrackArea())
      return (
        <TrackAisleControl
          handleSave={handleSave}
          classes={classes}
          handleClose={handleClose}
          requiresTargetRailcarVerification={
            targetRailcarVerificationState.requiresVerification
          }
          isTargetRailcarValidated={isTargetRailcarValidated}
        />
      );

    if (useBulkContainerFlow)
      return (
        <StructuredAisleControl
          handleDeleteButtonClick={handleDeleteButtonClick}
          handleSave={handleSave}
          handleAisleChange={handleAisleChange}
          classes={classes}
          allBarcodes={allBarcodes}
          setAllBarcodes={setAllBarcodes}
          pendingBarcodes={pendingBarcodes}
        />
      );

    if (isBulkArea(currentInventory?.area) || isBulkLocation(selectedAisle))
      return (
        <BulkAisleControl
          handleDeleteButtonClick={handleDeleteButtonClick}
          handleSave={handleSave}
          handleAisleChange={handleAisleChange}
          classes={classes}
          handleClose={handleClose}
        />
      );

    if (selectedAisle?.type === LocationType.STRUCTURED)
      return (
        <StructuredAisleControl
          handleDeleteButtonClick={handleDeleteButtonClick}
          handleSave={handleSave}
          handleAisleChange={handleAisleChange}
          classes={classes}
          allBarcodes={allBarcodes}
          setAllBarcodes={setAllBarcodes}
          pendingBarcodes={pendingBarcodes}
        />
      );

    return (
      <UnstructuredAisleControl
        handleDeleteButtonClick={handleDeleteButtonClick}
        handleSave={handleSave}
        handleAisleChange={handleAisleChange}
        classes={classes}
        handleClose={handleClose}
        allBarcodes={allBarcodes}
        setAllBarcodes={setAllBarcodes}
        pendingBarcodes={pendingBarcodes}
      />
    );
  };

  const getAisleView = () => {
    if (isCurrentTrackArea()) {
      const { selectedTrack, trackId, highlightShipmentId } =
        getWorkOrderTrackViewContext({
          currentInventory,
          currentShipment,
          selectedOutbound,
          selectedInventoryItem,
          selectedLocation,
          trackViewRailcarVerificationType:
            trackViewRailcarVerificationConfig.type,
        });
      const effectiveTrackLocation =
        resolvedTrackLocation?.id === trackId
          ? resolvedTrackLocation
          : selectedTrack;

      if (!trackId || !effectiveTrackLocation?.id) return null;
      const locationName = getTrackLocationRecordDisplayName(
        effectiveTrackLocation,
      );
      const trackLocationName =
        !locationName || locationName === "Unspotted" ? "Track" : locationName;
      return (
        <Grid container item xs={12} spacing={2}>
          <Grid item xs={12}>
            <Typography
              variant="body2"
              style={{ marginBottom: 8, textAlign: "center" }}
            >
              Location: {trackLocationName}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <TrackLocationView
              selectedTrack={effectiveTrackLocation}
              inventoryItem={selectedInventoryItem}
              highlightShipmentId={highlightShipmentId}
              hideSelectedRailcar={
                trackViewRailcarVerificationConfig.hideSelectedRailcar
              }
              targetRailcarInput={
                trackViewRailcarVerificationConfig.type === "receiving"
                  ? targetRailcarInput
                  : undefined
              }
              targetRailcarError={
                trackViewRailcarVerificationConfig.type === "receiving"
                  ? targetRailcarError
                  : false
              }
              onTargetRailcarInputChange={
                trackViewRailcarVerificationConfig.type === "receiving"
                  ? (value) => {
                      setTargetRailcarInput(value);
                      setTargetRailcarError(false);
                      setIsTargetRailcarValidated(false);
                    }
                  : undefined
              }
              onValidateTargetRailcar={
                trackViewRailcarVerificationConfig.type === "receiving"
                  ? handleValidateTargetRailcar
                  : undefined
              }
            />
          </Grid>
        </Grid>
      );
    }

    if (!selectedAisle) return;

    if (useBulkContainerFlow)
      return (
        <Grid container item xs={12}>
          <StructuredInboundAisle handleLocation={handleLocation} />
        </Grid>
      );

    if (isBulkArea(currentInventory?.area) || isBulkLocation(selectedAisle))
      return (
        <Grid container item xs={12}>
          <BulkInboundAisle />
        </Grid>
      );

    if (selectedAisle.type === LocationType.STRUCTURED)
      return (
        <Grid container item xs={12}>
          <StructuredInboundAisle handleLocation={handleLocation} />
        </Grid>
      );

    return null;
  };

  const showAisleSearch = () => {
    return (
      selectedAisle?.type === LocationType.STRUCTURED ||
      selectedAisle?.type === LocationType.BULK
    );
  };

  return (
    <>
      <Backdrop className={classes.backdrop} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Box mt={2} mx={2}>
        <Grid container spacing={2}>
          {getLocationControl()}
          {!isCurrentTrackArea() && (
            <Grid item xs={12}>
              <Typography variant="subtitle1" color="textSecondary">
                {getSelectedLocationText()}
              </Typography>
            </Grid>
          )}
          <Grid item xs={12}>
            <Divider />
          </Grid>
          {!isCurrentTrackArea() && (
            <Grid item xs={12}>
              {isSmall ? (
                <>
                  {showAisleSearch() && (
                    <Grid item xs={12}>
                      <SearchInput
                        handleSearch={searchAisleInventories}
                        clear={clearSearchResults}
                        term={searchTerm}
                        setTerm={setSearchTerm}
                        termLength={3}
                      />
                    </Grid>
                  )}
                  {showCapacityDisplay && (
                    <Grid item xs={12}>
                      <FormControlLabel
                        label={getSwitchLabel()}
                        control={
                          <Switch
                            checked={showInventoryQuantity}
                            onChange={handleDisplayChange}
                            color="primary"
                          />
                        }
                      />
                    </Grid>
                  )}
                  {showLocationInventories() && (
                    <Grid item xs={12}>
                      <Button
                        disabled={
                          !selectedLocation?.id ||
                          locationInventories.length === 0
                        }
                        onClick={() => setShowInventories(true)}
                        startIcon={<VisibilityIcon />}
                        size="large"
                      >
                        View Inventories
                      </Button>
                    </Grid>
                  )}
                  {getLocationCapacity()}
                </>
              ) : (
                <>
                  {
                    <Grid item xs={12}>
                      <Box
                        mb={2}
                        display="flex"
                        style={{ width: "100%" }}
                        justifyContent={
                          selectedAisle?.type === LocationType.UNSTRUCTURED
                            ? "flex-end"
                            : "space-between"
                        }
                        alignItems="center"
                      >
                        {showAisleSearch() && (
                          <SearchInput
                            handleSearch={searchAisleInventories}
                            clear={clearSearchResults}
                            term={searchTerm}
                            setTerm={setSearchTerm}
                            termLength={3}
                          />
                        )}
                        <Box display="flex">
                          {showCapacityDisplay && (
                            <FormControlLabel
                              label={getSwitchLabel()}
                              control={
                                <Switch
                                  checked={showInventoryQuantity}
                                  onChange={handleDisplayChange}
                                  color="primary"
                                />
                              }
                            />
                          )}
                          {showLocationInventories() && (
                            <Button
                              disabled={
                                !selectedLocation?.id ||
                                locationInventories.length === 0
                              }
                              onClick={() => setShowInventories(true)}
                              startIcon={<VisibilityIcon />}
                              size="large"
                            >
                              View Inventories
                            </Button>
                          )}
                        </Box>
                      </Box>
                    </Grid>
                  }
                  {getLocationCapacity()}
                </>
              )}
              <InventoriesDialog
                currentInventory={currentInventory}
                showInventories={showInventories}
                setShowInventories={setShowInventories}
                isSmall={isSmall}
                selectedLocation={selectedLocation}
                locationInventories={locationInventories}
                isShipmentInventoryItem={isShipmentInventoryItem}
              />
            </Grid>
          )}
        </Grid>
      </Box>
      <Confirm
        isOpen={showLocationChangeDialog}
        title="Location Change Confirmation"
        content={
          <>
            Changing the location will transfer the barcodes scanned by you to
            the new location.
            <br />
            <strong>Confirm</strong> If you want to transfer the barcodes in the
            new location,
            <br />
            <strong>Cancel</strong> to keep the barcodes in the current
            location.
          </>
        }
        onConfirm={handleDialogConfirm}
        onClose={handleCancelLocationChange}
      />
      {getAisleView()}
      <Box mx={2} mb={1} display={"flex"} flex={1} justifyContent={"flex-end"}>
        <Button onClick={handleClose}>Close</Button>
      </Box>
      <Confirm
        isOpen={isDeleteInventoryItemOpen}
        title={"Delete Inventory Item"}
        content={getConfirmDialogText()}
        onConfirm={handleDelete}
        onClose={() => setIsDeleteInventoryItemOpen(false)}
      />
    </>
  );
};
